/* eslint-disable prettier/prettier */
const Styles = {
  buttonBaseStyle: {
    width: "20%",
    "&:hover": {
      backgroundColor: "#043D90",
      color: "white",
    },
  },
  container: {
    width: "100%",
    height: "100%",
    backgroundColor: "#fff",
  },
  main: {
    borderRadius: 8,
    marginBottom: "1rem",
    height: "100%",
  },
  boxStyle: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    alignItems: "center",
    padding: "25px 0px",
  },
  cardStyles: {
    background: "#EDF5F9",
    borderRadius: "10px",
    padding: "10px",
  },
  syncRolesPermissions: {
    backgroundColor: "#28549B",
  },
  freezeSystem: {
    backgroundColor: "rgb(255, 1, 0);",
  },
  newfreezeSystem: {
    backgroundColor: "#3678C2",
  },
  defreezeSystem: {
    backgroundColor: "#38AFC5",
  },
  attendanceUnmarkedEmailer: {
    backgroundColor: "#38AFC5",
    "&:hover": {
      backgroundColor: "#2E9AB0",
    },
  },
  defreezeSystem2: {
    backgroundColor: "#00A8E8",
  },
};

export default Styles;
